import _ from 'underscore';
import React, { useCallback } from 'react';
import {
  TabList,
  Tab,
  mergeClasses,
} from '@fluentui/react-components';

import { ToolGroupConfig } from './types';
import { useMenuStyles } from './styles';

export const ToolsMenu: React.FC<{
  groups: ToolGroupConfig[];
  selectedGroup: string;
  // eslint-disable-next-line no-unused-vars
  onGroupSelect: (group: string) => void;
}> = ({
  groups, selectedGroup, onGroupSelect,
}) => {
  const classes = useMenuStyles();

  const onTabSelect = useCallback((_e, data) => {
    const groupId = data.value as string;

    onGroupSelect(groupId);
  }, [onGroupSelect]);

  return (
    <TabList
      className={mergeClasses('tools-menu', classes.root, classes.rootMobileView)}
      vertical
      selectedValue={selectedGroup}
      onTabSelect={onTabSelect}
    >
      {_.map(groups, (group) => (
        <Tab
          className={mergeClasses('tools-menu-item', group.key, classes.item)}
          value={group.key}
          aria-label={group.name}
        >
          {group.name}
        </Tab>
      ))}
    </TabList>
  );
};
